import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06f50c7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content-link-page-container" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "text-container" };
const _hoisted_4 = { class: "title" };
const _hoisted_5 = { class: "description" };
const _hoisted_6 = { class: "url-tooltip" };
const _hoisted_7 = ["href"];
const _hoisted_8 = { class: "open-link-btn-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BrokenImage = _resolveComponent("BrokenImage");
    const _component_ThemedButton = _resolveComponent("ThemedButton");
    const _component_FriedFloater = _resolveComponent("FriedFloater");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(['content-link-text-content', { 'no-image': !_ctx.hasImage }])
        }, [
            _createElementVNode("div", {
                class: _normalizeClass([['image-container', { 'no-image': !_ctx.hasImage }], ""])
            }, [
                _createVNode(_Transition, { name: "appear" }, {
                    default: _withCtx(() => [
                        (_ctx.hasImage && !_ctx.imageBroken)
                            ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.imageUrl,
                                class: "content-link-thumbnail",
                                onError: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleLoadImageError && _ctx.handleLoadImageError(...args))),
                                onLoad: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleLoaded && _ctx.handleLoaded(...args)))
                            }, null, 40, _hoisted_2)), [
                                [_vShow, _ctx.imageLoaded]
                            ])
                            : (_ctx.imageBroken)
                                ? (_openBlock(), _createBlock(_component_BrokenImage, { key: 1 }))
                                : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 2),
            _createElementVNode("div", {
                class: _normalizeClass(['content-link-text-container', { 'no-image': !_ctx.hasImage }])
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.description), 1)
                ]),
                _createVNode(_component_FriedFloater, {
                    class: "button-container",
                    show: _ctx.tooltipOpen,
                    placement: "bottom-end",
                    "main-axis-offset": 0,
                    "cross-axis-offset": 8
                }, {
                    reference: _withCtx(() => [
                        _createVNode(_component_ThemedButton, {
                            class: "open-link-btn",
                            theme: _ctx.theme,
                            "data-external": "content-link-page-open-link-button",
                            onClick: _ctx.handleClick
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.buttonText), 1)
                            ]),
                            _: 1
                        }, 8, ["theme", "onClick"])
                    ]),
                    default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("a", {
                                href: _ctx.url,
                                target: "_blank",
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.closeTooltip && _ctx.closeTooltip(...args)))
                            }, _toDisplayString(_ctx.url), 9, _hoisted_7)
                        ])), [
                            [_directive_click_outside, _ctx.closeTooltip]
                        ])
                    ]),
                    _: 1
                }, 8, ["show"])
            ], 2)
        ], 2)
    ]));
}
